import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "box", "icon"]
  static values = {
    checked: Boolean,
    variant: String
  }

  connect() {
    // Initialize UI based on input's checked state
    if (this.hasInputTarget) {
      this.updateUI()
    }
  }

  toggle(event) {
    // Update UI when checkbox changes
    this.checkedValue = this.inputTarget.checked
    this.updateUI()
  }

  updateUI() {
    const isChecked = this.inputTarget.checked

    if (this.variantValue === "checkmark") {
      if (isChecked) {
        this.boxTarget.classList.remove("bg-gray-100", "dark:bg-gray-800")
        this.boxTarget.classList.add("border-brand-500", "!bg-brand-500")
        this.iconTarget.classList.remove("opacity-0")
        this.iconTarget.classList.add("!opacity-100")
      } else {
        this.boxTarget.classList.remove("border-brand-500", "!bg-brand-500")
        this.boxTarget.classList.add("bg-gray-100", "dark:bg-gray-800")
        this.iconTarget.classList.add("opacity-0")
        this.iconTarget.classList.remove("!opacity-100")
      }
    } else if (this.variantValue === "square") {
      if (isChecked) {
        this.boxTarget.classList.add("border-brand-500", "bg-gray-100", "dark:bg-transparent")
        this.iconTarget.classList.add("bg-brand-500")
      } else {
        this.boxTarget.classList.remove("border-brand-500", "bg-gray-100", "dark:bg-transparent")
        this.iconTarget.classList.remove("bg-brand-500")
      }
    } else if (this.variantValue === "x-mark") {
      if (isChecked) {
        this.boxTarget.classList.add("border-brand-500", "bg-gray-100", "dark:bg-transparent")
        this.iconTarget.classList.remove("opacity-0")
        this.iconTarget.classList.add("!opacity-100")
      } else {
        this.boxTarget.classList.remove("border-brand-500", "bg-gray-100", "dark:bg-transparent")
        this.iconTarget.classList.add("opacity-0")
        this.iconTarget.classList.remove("!opacity-100")
      }
    } else if (this.variantValue === "circle") {
      if (isChecked) {
        this.boxTarget.classList.add("border-brand-500")
        this.iconTarget.classList.add("!bg-brand-500")
        this.iconTarget.classList.remove("bg-transparent")
      } else {
        this.boxTarget.classList.remove("border-brand-500")
        this.iconTarget.classList.remove("!bg-brand-500")
        this.iconTarget.classList.add("bg-transparent")
      }
    } else if (this.variantValue === "circle-filled") {
      if (isChecked) {
        this.boxTarget.classList.add("!border-4")
      } else {
        this.boxTarget.classList.remove("!border-4")
      }
    }
  }
}
